"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
const SOFT_LIGHT_BLEND_MODE = {
  mixBlendMode: "soft-light"
};
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 50 31"
  }, react_1.default.createElement("defs", null, react_1.default.createElement("linearGradient", {
    id: "a",
    x1: "-.003%",
    y1: "49.996%",
    y2: "49.996%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#1E6CB5"
  }), react_1.default.createElement("stop", {
    offset: "8%",
    stopColor: "#226EB7"
  }), react_1.default.createElement("stop", {
    offset: "30%",
    stopColor: "#2570B8"
  }), react_1.default.createElement("stop", {
    offset: "54%",
    stopColor: "#1A62AF"
  }), react_1.default.createElement("stop", {
    offset: "74%",
    stopColor: "#165CAB"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#253D81"
  })), react_1.default.createElement("linearGradient", {
    id: "b",
    x1: "0%",
    y1: "50.012%",
    y2: "50.012%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), react_1.default.createElement("stop", {
    offset: "19%",
    stopColor: "#FBFCFE"
  }), react_1.default.createElement("stop", {
    offset: "40%",
    stopColor: "#EEF5FA"
  }), react_1.default.createElement("stop", {
    offset: "61%",
    stopColor: "#D8E8F4"
  }), react_1.default.createElement("stop", {
    offset: "83%",
    stopColor: "#BAD7EB"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#9EC6E3"
  })), react_1.default.createElement("linearGradient", {
    id: "c",
    x1: "-.001%",
    y1: "49.999%",
    y2: "49.999%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#F8FCFF"
  }), react_1.default.createElement("stop", {
    offset: "24%",
    stopColor: "#F4F9FE"
  }), react_1.default.createElement("stop", {
    offset: "50%",
    stopColor: "#E7F2F9"
  }), react_1.default.createElement("stop", {
    offset: "77%",
    stopColor: "#D1E5F2"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#B8D6EA"
  })), react_1.default.createElement("linearGradient", {
    id: "d",
    x1: "7171%",
    x2: "8404%",
    y1: "7218%",
    y2: "7218%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#F8FCFF"
  }), react_1.default.createElement("stop", {
    offset: "24%",
    stopColor: "#F4F9FE"
  }), react_1.default.createElement("stop", {
    offset: "50%",
    stopColor: "#E7F2F9"
  }), react_1.default.createElement("stop", {
    offset: "77%",
    stopColor: "#D1E5F2"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#B8D6EA"
  })), react_1.default.createElement("linearGradient", {
    id: "e",
    x1: "10360%",
    x2: "11592%",
    y1: "9059%",
    y2: "9059%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#F8FCFF"
  }), react_1.default.createElement("stop", {
    offset: "24%",
    stopColor: "#F4F9FE"
  }), react_1.default.createElement("stop", {
    offset: "50%",
    stopColor: "#E7F2F9"
  }), react_1.default.createElement("stop", {
    offset: "77%",
    stopColor: "#D1E5F2"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#B8D6EA"
  })), react_1.default.createElement("linearGradient", {
    id: "f",
    x1: "26.583%",
    x2: "75.544%",
    y1: "123.192%",
    y2: "-.65%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: "0"
  }), react_1.default.createElement("stop", {
    offset: "3%",
    stopColor: "#FFF",
    stopOpacity: ".14"
  }), react_1.default.createElement("stop", {
    offset: "8%",
    stopColor: "#FFF",
    stopOpacity: ".34"
  }), react_1.default.createElement("stop", {
    offset: "13%",
    stopColor: "#FFF",
    stopOpacity: ".52"
  }), react_1.default.createElement("stop", {
    offset: "18%",
    stopColor: "#FFF",
    stopOpacity: ".67"
  }), react_1.default.createElement("stop", {
    offset: "24%",
    stopColor: "#FFF",
    stopOpacity: ".79"
  }), react_1.default.createElement("stop", {
    offset: "29%",
    stopColor: "#FFF",
    stopOpacity: ".88"
  }), react_1.default.createElement("stop", {
    offset: "35%",
    stopColor: "#FFF",
    stopOpacity: ".95"
  }), react_1.default.createElement("stop", {
    offset: "42%",
    stopColor: "#FFF",
    stopOpacity: ".99"
  }), react_1.default.createElement("stop", {
    offset: "50%",
    stopColor: "#FFF"
  }), react_1.default.createElement("stop", {
    offset: "58%",
    stopColor: "#FFF",
    stopOpacity: ".99"
  }), react_1.default.createElement("stop", {
    offset: "65%",
    stopColor: "#FFF",
    stopOpacity: ".95"
  }), react_1.default.createElement("stop", {
    offset: "71%",
    stopColor: "#FFF",
    stopOpacity: ".88"
  }), react_1.default.createElement("stop", {
    offset: "76%",
    stopColor: "#FFF",
    stopOpacity: ".79"
  }), react_1.default.createElement("stop", {
    offset: "82%",
    stopColor: "#FFF",
    stopOpacity: ".67"
  }), react_1.default.createElement("stop", {
    offset: "87%",
    stopColor: "#FFF",
    stopOpacity: ".52"
  }), react_1.default.createElement("stop", {
    offset: "92%",
    stopColor: "#FFF",
    stopOpacity: ".34"
  }), react_1.default.createElement("stop", {
    offset: "97%",
    stopColor: "#FFF",
    stopOpacity: ".14"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: "0"
  }))), react_1.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react_1.default.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M35.008 4.176c2.21.973 10.094 3.043 13.62 5.825 1.013.8 1.357 2.765 1.357 2.765a1.783 1.783 0 0 1-.674 1.619s-12.826 8.946-21.35 13.873a12.177 12.177 0 0 1-10.166.934C14.189 27.921 7.079 23.458 6.01 19.07c-.12-.514 2.038-4.267 2.718-4.617.68-.349.602 4.253 1.038 3.954C14.33 15.27 27.544 5.715 33.21 4.063a2.626 2.626 0 0 1 1.798.113z"
  }), react_1.default.createElement("path", {
    fill: "url(#b)",
    fillRule: "nonzero",
    d: "M3.834 30.923L0 28.703l13.299-6.366 3.834 2.22z"
  }), react_1.default.createElement("path", {
    fill: "#FEDB32",
    fillRule: "nonzero",
    d: "M0 28.703l3.834 2.22.965-.462-3.84-2.216z"
  }), react_1.default.createElement("path", {
    fill: "#125BAA",
    fillRule: "nonzero",
    d: "M2.674 27.424l.814.476 2.788-1.373-.79-.45zM6.012 29.874l3.222-1.543-1.054-.587-2.931 1.567z"
  }), react_1.default.createElement("path", {
    fill: "url(#c)",
    fillRule: "nonzero",
    d: "M33.971.223C36.813 1.47 47.415 7.813 48.622 10c0 0-13.18 9.38-21.705 14.304a12.177 12.177 0 0 1-10.166.934c-3.6-1.271-8-3.69-9.068-8.08a2.563 2.563 0 0 1 1.037-2.706C13.284 11.318 26.498 1.763 32.164.11a2.626 2.626 0 0 1 1.807.113z"
  }), react_1.default.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "nonzero",
    d: "M13.65 13.36c1.057-.463 2.838-.13 3.977.744 1.139.874 1.205 1.956.147 2.418-1.058.461-2.836.129-3.975-.745-1.14-.874-1.206-1.948-.15-2.418z"
  }), react_1.default.createElement("path", {
    fill: "#4E4E4E",
    fillRule: "nonzero",
    d: "M13.552 13.07c1.201-.524 3.22-.148 4.512.845 1.293.992 1.368 2.217.168 2.742-1.199.524-3.213.147-4.512-.845-1.299-.992-1.367-2.218-.168-2.742z",
    style: SOFT_LIGHT_BLEND_MODE
  }), react_1.default.createElement("path", {
    fill: "#4E4E4E",
    fillRule: "nonzero",
    d: "M13.828 13.282c1.058-.464 2.838-.129 3.977.743 1.139.872 1.205 1.956.147 2.42-1.058.464-2.836.129-3.97-.743-1.136-.872-1.21-1.958-.154-2.42z"
  }), react_1.default.createElement("path", {
    fill: "#676767",
    fillRule: "nonzero",
    d: "M17.627 14.104c1.107.849 1.2 1.893.234 2.376l.091-.035c1.058-.464.992-1.546-.147-2.42-1.139-.874-2.92-1.207-3.977-.743l-.087.04c1.07-.406 2.78-.067 3.886.782z"
  }), react_1.default.createElement("path", {
    fill: "url(#d)",
    fillRule: "nonzero",
    d: "M15.562 15.758l-.684-1.481 2.556.397z"
  }), react_1.default.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "nonzero",
    d: "M25.635 20.298c.797-.612.222-1.644-1.286-2.303-1.509-.66-3.378-.697-4.177-.086-.799.612-.222 1.644 1.284 2.303 1.507.66 3.38.691 4.179.086z"
  }), react_1.default.createElement("path", {
    fill: "#4E4E4E",
    fillRule: "nonzero",
    d: "M26.135 20.354c.904-.695.253-1.873-1.452-2.611-1.706-.739-3.834-.793-4.739-.098-.905.695-.253 1.873 1.452 2.611 1.706.739 3.832.793 4.739.098z",
    style: SOFT_LIGHT_BLEND_MODE
  }), react_1.default.createElement("path", {
    fill: "#4E4E4E",
    fillRule: "nonzero",
    d: "M25.768 20.194c.798-.612.224-1.642-1.285-2.301-1.508-.66-3.377-.7-4.176-.086-.799.614-.224 1.642 1.284 2.301 1.509.66 3.386.7 4.177.086z"
  }), react_1.default.createElement("path", {
    fill: "#676767",
    fillRule: "nonzero",
    d: "M24.355 17.99c-1.465-.64-3.272-.694-4.106-.135l.064-.052c.799-.624 2.668-.574 4.177.085 1.508.66 2.074 1.69 1.284 2.302a.432.432 0 0 1-.07.05c.694-.612.103-1.605-1.35-2.25z"
  }), react_1.default.createElement("path", {
    fill: "url(#e)",
    fillRule: "nonzero",
    d: "M21.494 19.19l2.556.398-.685-1.481z"
  }), react_1.default.createElement("path", {
    fill: "#CFDDD3",
    fillRule: "nonzero",
    d: "M30.006 16.813l-11.35-6.573 13.59-8.022L43.599 8.79z"
  }), react_1.default.createElement("path", {
    fill: "#B0C1B6",
    fillRule: "nonzero",
    d: "M30.828 4.577l-1.396.978H29v-.304l1.396-.978h.432v.304zM28.88 5.942l-1.47 1.022h-.433V6.66l1.47-1.04h.433v.322zm2.5-1.664l1.381.97v.303h-.433l-1.382-.97v-.303h.434zm-1.948 1.364l1.381.97v.304h-.431L29 5.948v-.304l.432-.002zM27.41 7.06l1.382.97v.304h-.434l-1.382-.97v-.304h.434zm5.363-1.117l-1.394.978h-.434v-.304l1.394-.978h.434v.304zm-1.948 1.365l-1.47 1.04h-.433v-.304l1.471-1.03h.432v.294zM33.84 6.689l-1.394.978h-.434v-.304l1.395-.978h.433v.304zm-1.946 1.365l-1.469 1.03h-.433V8.78l1.469-1.04h.433v.314zm2.49-1.665l1.382.968v.304h-.434l-1.382-.97v-.302h.434zm-1.938 1.365l1.382.97v.303h-.432l-1.384-.97v-.303h.434zm-2.023 1.42l1.384.967v.303h-.434l-1.381-.967v-.304h.431zm5.365-1.12l-1.394.978h-.433v-.304l1.394-.978h.433v.304zM33.84 9.419l-1.469 1.04h-.433v-.304l1.47-1.04h.432v.304zM36.855 8.803l-1.394.978h-.434v-.302l1.394-.978h.434v.302zm-1.946 1.365l-1.47 1.03h-.433v-.304l1.47-1.03h.433v.304zm2.49-1.665l1.381.97v.301h-.434l-1.381-.967v-.304h.433zM35.46 9.876l1.381.968v.304h-.433l-1.382-.968v-.304h.434zm-2.023 1.417l1.384.97v.303h-.434l-1.382-.97v-.303h.432zm5.365-1.117l-1.394.976h-.434v-.304l1.394-.976h.434v.304zm-1.948 1.365l-1.47 1.04h-.433v-.304l1.47-1.04h.433v.304z"
  }), react_1.default.createElement("path", {
    fill: "#595A5C",
    fillRule: "nonzero",
    d: "M32.774 5.942l-1.394.978-.434-.004-.006-.304 1.394-.978.434.004zM30.826 7.307l-1.47 1.03-.433-.004-.006-.304 1.469-1.03.434.004zM33.886 6.722l-1.394.978-.434-.004-.006-.304 1.394-.978.434.004zM31.94 8.087l-1.471 1.03-.434-.004-.006-.304 1.471-1.03.434.004zM34.44 6.423l1.382.97.006.303-.434-.004-1.382-.97-.006-.304zM30.469 9.204l1.382.97.006.304-.434-.005-1.382-.97-.006-.303zM35.834 8.087l-1.394.978-.434-.004L34 8.757l1.394-.978.434.004zM33.886 9.452l-1.469 1.03-.434-.004-.006-.304 1.47-1.03.433.004zM36.836 8.79l-1.394.978-.434-.004-.006-.304 1.394-.978.434.005zM35.442 9.856l1.382.967.006.304-.434-.004-1.381-.968-.007-.304zM38.784 10.155l-1.394.978-.434-.006-.006-.304 1.394-.976.434.004z"
  }), react_1.default.createElement("path", {
    d: "M36.836 11.52l-1.469 1.03-.433-.004-.007-.304 1.47-1.03.433.004z"
  }), react_1.default.createElement("g", {
    fill: "#595A5C",
    fillRule: "nonzero"
  }, react_1.default.createElement("path", {
    d: "M33.012 13.74l.716-.504-.122-.085-.83.587.519.362.12-.083z"
  }), react_1.default.createElement("path", {
    d: "M33.33 12.959l-.305.312a.419.419 0 0 0-.015-.125.271.271 0 0 0-.064-.106c-.067-.07-.15-.099-.23-.078a.168.168 0 0 0-.106.044 1.103 1.103 0 0 0-.164.15c-.05.05-.097.106-.141.168a.234.234 0 0 0-.046.116.283.283 0 0 0 .01.125.27.27 0 0 0 .067.118.27.27 0 0 0 .218.085l-.062.065.116.122.83-.88-.108-.116zm-.604.624a.578.578 0 0 1-.072.06.119.119 0 0 1-.075 0 .16.16 0 0 1-.083-.05c-.03-.031-.044-.056-.048-.084a.156.156 0 0 1 0-.082.259.259 0 0 1 .046-.078l.064-.075c.023-.025.05-.047.073-.068a.239.239 0 0 1 .072-.047.11.11 0 0 1 .077 0 .16.16 0 0 1 .079.05c.022.02.039.05.048.087a.124.124 0 0 1-.01.081.462.462 0 0 1-.044.078l-.067.07-.06.058zM32.807 12.581l-1.124.416.089.063 1.124-.417z"
  }), react_1.default.createElement("path", {
    d: "M32.066 12.466l-.064.058a.246.246 0 0 0-.077-.206.243.243 0 0 0-.116-.067.31.31 0 0 0-.11 0 .309.309 0 0 0-.104.037c-.06.042-.118.09-.174.144a.915.915 0 0 0-.147.16.215.215 0 0 0-.03.2.23.23 0 0 0 .071.108.272.272 0 0 0 .208.075l-.062.059a.2.2 0 0 1-.133.055.207.207 0 0 1-.129-.058.158.158 0 0 1-.043-.075.21.21 0 0 1-.015-.081l-.164-.017c-.012.112.028.221.1.279.153.146.359.146.512 0l.583-.557-.106-.114zm-.398.364a.108.108 0 0 1-.062.023.17.17 0 0 1-.065 0 .145.145 0 0 1-.114-.109.13.13 0 0 1 0-.061.122.122 0 0 1 .027-.059.76.76 0 0 1 .09-.091.96.96 0 0 1 .101-.087.118.118 0 0 1 .062-.025.277.277 0 0 1 .067 0c.026.008.05.022.072.042.02.016.034.04.042.067a.16.16 0 0 1 0 .061.118.118 0 0 1-.025.059l-.093.094a.805.805 0 0 1-.102.086zM31.456 12.044a.179.179 0 0 0-.085-.13.414.414 0 0 0-.265-.078.209.209 0 0 0 0-.087.224.224 0 0 0-.079-.086.35.35 0 0 0-.24-.06l.062-.044-.117-.08-.595.415.116.082.355-.25a.221.221 0 0 1 .249 0c.032.017.052.05.054.085a.12.12 0 0 1-.062.09l-.357.25.116.08.357-.25a.207.207 0 0 1 .128-.04c.043-.002.085.01.12.035a.1.1 0 0 1 .053.085c0 .031-.02.06-.06.09l-.357.249.116.081.396-.279a.177.177 0 0 0 .095-.158z"
  })), react_1.default.createElement("path", {
    fill: "#595A5C",
    fillRule: "nonzero",
    d: "M36.836 11.52l-1.469 1.03-.433-.004-.007-.304 1.47-1.03.433.004z"
  }), react_1.default.createElement("path", {
    fill: "url(#f)",
    fillRule: "nonzero",
    d: "M19.077 8.715l.809.35 17.407-2.632-.81-.35-17.406 2.632zm19.17-1.872L20.84 9.475l4.994 2.164 17.4-2.628-4.987-2.168z",
    opacity: ".2"
  })));
};